<div class="popover is-popover-bottom nav-popover">
  <a
    on:click|stopPropagation="{toggleGlossar}"
    class="button is-small mr-2 popover-trigger"
    title="Glossar anzeigen"
  ><Icon icon="book" size="medium" iconSize="fa-1x" type="grey" /></a>
  <div class="popover-content">Glossar anzeigen</div>
</div>

{#if glossarShown}
  <div class="glossar has-text-left {fadeGlossar ? 'glossar-visible' : ''}">
    <h3 class="is-size-3">
      Glossar
      <button
        class="button is-small mr-1"
        style="float: right"
        on:click|stopPropagation="{toggleGlossar}"
      >
        <span class="icon is-small"> <i class="fa fa-times"></i> </span>
      </button>
    </h3>
    <input
      class="input"
      type="text"
      on:keyup="{filter}"
      bind:value="{filterValue}"
      placeholder="Durchsuche Glossar .."
    />
    {#if filteredGlossar}
      <div class="glossar-count">Zeige {filteredGlossar.length} Einträge</div>
      <div class="glossar-content">
        {#each filteredGlossar as item}
          <div class="glossar-item">
            <div class="glossar-term">{item.term}</div>
            <div class="glossar-description">
              {#each item.text as text}{text}<br />{/each}
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
{/if}

<script>
import { onMount } from "svelte";
import Icon from "./Icon.svelte";

let elems = [
  {
    term: "Abschlag",
    text: [
      "Der erste Schlag auf einem Loch",
      "Unter Regelaspekten: Die Fläche zwischen den Abschlagmarkierungen, rechtwinklig und zwei Schlägerlängen tief von der äußeren vordere Ecke der beiden Markierungen gemessen.",
      "Aus Sicht des Greenkeepers: Die ebene Fläche, die dazu gebaut wurde, die Abschlagmarkierungen zu setzen.",
    ],
  },
  {
    term: "Abschwung",
    text: [
      'Ungebräuchlicher Begriff. Die Vorwärtsbewegung des Schlägers zum Ball ist der „Schlag".',
    ],
  },
  {
    term: "Adress ",
    text: ["siehe „Ansprechen“"],
  },
  {
    term: "Albatros",
    text: [
      "Wenn man ein Loch, das als Par 5 ausgewiesen wird, in zwei Schlägen schafft, nennt man das einen Albatros. Das bedeutet, dass man das Loch in 'drei unter Par' gespielt hat.",
    ],
  },
  {
    term: "All Square",
    text: [
      "So wird der Gleichstand nach Ende der Runde im Lochspiel bezeichnet, ein Gleichstand auf der Runde heißt nur „square“.",
    ],
  },
  {
    term: "Amateur",
    text: [
      "Es gibt keine andere Sportart, in der die Trennung zwischen Amateuren und Pros so streng eingehalten wird, wie gerade im Golf. Im Amateurstatut wird der Amateurbegriff wie folgt definiert 'Golfamateur ist, wer Golf als Sport frei von Vergütung oder Bereicherung spielt.",
    ],
  },
  {
    term: "Annäherung",
    text: [
      "Dieses sind die wichtigsten Schläge des ganzen Spiels - jene, mit denen man sich der Fahne annähert. Mit zwischenmenschlichen Beziehungen hat diese Annäherung rein gar nichts zu tun.",
    ],
  },
  {
    term: "Approach ",
    text: ["siehe „Annäherung“"],
  },
  {
    term: "Ass",
    text: [
      "Das Spielen einer Spielbahn mit nur einem Schlag vom Tee bis ins Loch, auch Hole-in-One genannt.  ",
    ],
  },
  {
    term: "Aus-Ball",
    text: [
      'Schlägt ein Golfer seinen Ball ins Aus, im Englischen als "out of bounds"(auch „OB“) bezeichnet, muss er von derselben Stelle einen neuen Ball spielen und zieht sich zusätzlich einen Strafschlag zu. Weiße Pfosten oder Zäune zeigen meist die Aus-Grenze an.',
    ],
  },
  {
    term: "Ausgrenze",
    text: [
      "Die Ausgrenzen des Golfplatzes sind durch weiße Pfähle gekennzeichnet. Landet der Ball im Aus (engl. out of bounds), muss von der gleichen Stelle ein zweiter Ball geschlagen werden. Natürlich gibt´s einen Strafschlag.",
    ],
  },
  {
    term: "Auslippen",
    text: [
      "Die obere Erdkante des Lochs über dem Rand der Kunststoffhülse wird als Lippe bezeichnet. Ein scheinbar ins Loch fallender Ball „lippt oft noch aus“, wenn der Ball zu schnell am Loch ankommt.",
    ],
  },
  {
    term: "Ausrüstung",
    text: [
      "Ausrüstung ist alles, was vom oder für den Spieler benutzt, getragen oder mitgeführt wird, ausgenommen jeglicher Ball, den er an dem zu spielenden Loch gespielt hat, und jeglicher kleine Gegenstand wie Münze oder Tee, wenn er benutzt worden ist, um die Lage eines Balls oder die Ausdehnung einer Fläche, wo ein Ball fallengelassen werden muss, zu kennzeichnen.",
      "Ausrüstung schließt Golfwagen ein - gleich ob motorisiert oder nicht. Benutzen zwei oder mehr Spieler einen solchen Wagen gemeinsam, so gilt er samt allem, was er enthält, als Ausrüstung desjenigen Spielers, dessen Ball betroffen ist; solange jedoch der Wagen von einem der ihn gemeinsam benutzenden Spieler bewegt wird, gilt er samt allem, was er enthält, als Ausrüstung des betreffenden Spielers. Anmerkung: Ein an dem zu spielenden Loch gespielter Ball ist Ausrüstung, solange er aufgenommen und noch nicht wieder ins Spiel gebracht worden ist.",
    ],
  },
  {
    term: "Außergewöhnliches Ergebnis",
    text: [
      "Ein Ergebnis, dass mindestens 7 Schläge besser als der aktuelle Handicap-Index eines Spielers ausfällt. Hierfür wird das Handicap zusätzlich um einen (bei 7-9 Schlägen besser als der Handicap-Index) oder um 2 Schläge (bei 10 und mehr Schlägen unter dem Handicap-Index) reduziert.",
    ],
  },
  {
    term: "Back Door",
    text: [
      "Die „Hintertür“ des Lochs: Ein Ball, der halb um den Lochrand läuft und aus der entgegen gesetzten Richtung ins Loch fällt, wird „durch die Hintertür“ eingelocht. Sinngemäß gibt es einen „Seiteneingang“.",
    ],
  },
  {
    term: "Back Nine",
    text: ["Die zweiten neun Löcher eines Platzes."],
  },
  {
    term: "Backspin",
    text: [
      "Mancher Ball erhält durch den Schlag einen gewissen Rückwärtsdrall - den 'backspin' -, der das Flugverhalten ganz entscheidend beeinflusst. Der Backspin wird zunächst durch die Schräge der Schlagfläche des Schlägerkopfes Loft ausgelöst, und durch die darin befindlichen Rillen Grooves noch erhöht. Besonders erkennbar ist der Backspin, wenn ein Ball mit einem kurzen Eisen aufs Grün gespielt wird und nicht nur 'tot' liegen bleibt, sondern sogar noch ein Stück zurückrollt.  ",
    ],
  },
  {
    term: "Backswing",
    text: ["siehe „Rückschwung“  "],
  },
  {
    term: "Bag ",
    text: ['siehe "Golftasche"'],
  },
  {
    term: "Ball im Spiel",
    text: [
      "Ein Ball ist im Spiel, sobald der Spieler auf dem Abschlag einen Schlag ausgeführt hat. Er bleibt im Spiel, bis er eingelocht ist, es sei denn, er sei verloren, Aus oder aufgenommen oder durch einen anderen Ball ersetzt worden, gleich ob dies erlaubt ist oder nicht; ein solcher Ball wird Ball im Spiel.",
    ],
  },
  {
    term: "Beratung",
    text: [
      "Jede Art von Rat oder Anregung, welche einen Spieler in seiner Entscheidung über seine Spielweise, die Schlägerwahl oder die Ausführung eines Schlages beeinflussen könnte. Ein solcher Ratschlag darf ausschließlich von seinem Caddie oder Partner erfolgen. Hinweise zur Anwendung der Regeln oder eine Information über allgemein Kenntliches wie beispielsweise die Lage von Bunkern, Penalty Areas, dem Grün oder die Position des Flaggenstocks auf dem Grün zählt nicht als Beratung.",
    ],
  },
  {
    term: "Beobachter",
    text: [
      "Beobachter ist jemand, den die Spielleitung bestimmt hat, einem Platzrichter bei der Entscheidung von Tatfragen zur Seite zu stehen und ihm jeglichen Regelverstoß zu melden. Ein Beobachter soll nicht den Flaggenstock bedienen, am Loch stehen oder dessen Lage kennzeichnen, und soll auch nicht den Ball aufnehmen oder dessen Lage kennzeichnen.",
    ],
  },
  {
    term: "Besserlegen",
    text: [
      "Aufgrund schwieriger Witterungsverhältnisse, bei tiefem Boden oder zur Schonung des Bodens können Platzregeln erlassen werden, die ein Besserlegen des Balles erlauben - nie näher zur Fahne. In den meisten Fällen gibt man eine Scorekarten-Breite als Entfernung für das Besserlegen an. Selbstverständlich darf der Ball dabei gereinigt werden. s. Ziffer 9 DGV Vorgabensystem",
    ],
  },
  {
    term: "Bestball",
    text: [
      "Wettspiel, bei dem ein Spieler gegen den besten Ball einer Partie mit zwei oder drei Spielern spielt. Jeder Spieler spielt seinen eigenen Ball.  ",
    ],
  },
  {
    term: "Betterball  ",
    text: ['siehe "Vierball"'],
  },
  {
    term: "Bewegt ",
    text: [
      "Wenn ein Ball seine Lage verändert und an anderer Stelle zur Ruhe kommt, gilt er als bewegt.  ",
    ],
  },
  {
    term: "Birdie ",
    text: [
      "Lochergebnis ein Schlag unter Par, also beispielsweise auf einem Par-4-Loch eine 3.  ",
    ],
  },
  {
    term: "Blade ",
    text: [
      "Eisen mit einem Schlägerkopf ohne fehlerverzeihende Gewichtsverteilung.  ",
    ],
  },
  {
    term: "Blatt ",
    text: ["Die Schlagfläche eines Schlägerkopfes.  "],
  },
  {
    term: "Blaue Pfosten ",
    text: [
      "Damit wird angezeigt, daß sich hier 'Boden in Ausbesserung' befindet. Diese Markierung wird oft auch durch weiße Linien auf dem Boden angezeigt. Ein Ball, der hier landet, darf straffrei aus dieser Zone entfernt und fallengelassen werden - aber nicht näher zur Fahne.  ",
    ],
  },
  {
    term: "Blindes Loch",
    text: [
      "So bezeichnet man eine Spielbahn, bei der am Abschlag die Fahne nicht zu sehen ist, weil sie hinter Bäumen oder einem Hügel verdeckt ist. Natürlich kann man auch auf einer geraden Bahn zu 'blinden Schlägen' kommen, wenn der Ball in einer Lage ist, von der aus das Loch nicht zu sehen ist.  ",
    ],
  },
  {
    term: "Boden in Ausbesserung ",
    text: [
      "Boden in Ausbesserung ist jeder Teil des Platzes, der auf Anordnung der Spielleitung als solcher gekennzeichnet oder durch deren Befugte dazu erklärt worden ist. Eingeschlossen sind zur Beseitigung angehäuftes Material und von Platzpflegern gemachte Löcher, auch wenn sie nicht entsprechend gekennzeichnet sind. Pfosten und Linien, die Boden in Ausbesserung bezeichnen, liegen innerhalb dieses Bodens. Pfosten, die Boden in Ausbesserung bezeichnen, sind Hemmnisse. Boden in Ausbesserung erstreckt sich von den Grenzen senkrecht nach unten, aber nicht nach oben. Ein Ball ist im Boden in Ausbesserung, wenn er darin liegt oder ihn mit irgendeinem Teil berührt.",
      "Anmerkung 1: Abgeschnittenes Gras und andere Materialien, die auf dem Platz liegengelassen, aber nicht zur Beseitigung bestimmt wurden, sind nicht Boden in Ausbesserung, sofern sie nicht entsprechend gekennzeichnet sind.",
      "Anmerkung 2: Die Spielleitung darf durch Platzregel bestimmen, dass in Boden in Ausbesserung nicht gespielt werden darf.  ",
    ],
  },
  {
    term: "Bogey ",
    text: [
      "Lochergebnis ein Schlag über Par, also beispielsweise auf einem Par-3-Loch eine 4. Entsprechend gibt es auch noch den Doppel-Bogey (zwei über Par) oder gar den Triple-Bogey (drei über Par).  ",
    ],
  },
  {
    term: "Bogey Competition ",
    text: ["siehe „Gegen Par“  "],
  },
  {
    term: "Bounce ",
    text: [
      "Winkel vom tiefsten Punkt der Sohle eines Schlägerkopfes zur Vorderkante des Schlägers (Leading Edge) bei gerade aufgestelltem Schläger.  ",
    ],
  },
  {
    term: "Break ",
    text: [
      "Kurve, die der Ball auf dem Grün beschreibt, wenn dieses nicht eben ist.  ",
    ],
  },
  {
    term: "Brutto ",
    text: [
      "Mit diesem Begriff bezeichnet man die Schlagzahl, welche für das jeweilige Loch und über 18 Löcher gemacht wird. Nach Abzug der Vorgabe wird ein Nettoergebnis daraus.  ",
    ],
  },
  {
    term: "Bunker ",
    text: ["Künstlich angelegtes (Sand-)Hindernis - meist rund um das Grün.  "],
  },
  {
    term: "Caddie",
    text: [
      "Eine Person, die dem Spieler auf der Runde hilft, in dem sie den Spieler zu seinem nächsten Schlag berät und seine Schläger transportiert.",
    ],
  },
  {
    term: "Carry",
    text: [
      "Beim Golf ist die Distanz gemeint, die der Ball tatsächlich geflogen ist - ohne jene Strecke, die er nach seiner Landung noch rollte.",
    ],
  },
  {
    term: "Cart",
    text: [
      "Motorisiertes Gefährt, das Golfer benutzen, um eine Runde zu spielen.",
    ],
  },
  {
    term: "Cavity-back",
    text: [
      "Form des Schlägerkopfes, bei der sich die Gewichtsverteilung wie ein Kranz um die Rückseite des Schlägerblattes zieht.",
    ],
  },
  {
    term: "Chip",
    text: [
      "Ein Annäherungsschlag aus der unmittelbaren Nähe des Grüns, der nach Möglichkeit das Loch oder seine Nähe erreichen sollte. Einer der wichtigsten Schläge dieses Spiels überhaupt.",
    ],
  },
  {
    term: "Chipping Area",
    text: [
      "Teil der Driving Range, auf dem Sie die kurzen Annäherungsschläge (Chippen und Pitchen) trainieren können.",
    ],
  },
  {
    term: "Club",
    text: [
      "Selbst Nichtgolfer wissen, dass damit ein ganz schlichter Verein gemeint ist - und schließlich ist ein Golfclub auch ein Sportverein. Was Nichtgolfer allerdings nicht wissen, ist die Tatsache, dass man in der englischen Golfsprache mit 'clubs' auch die Schläger bezeichnet.",
    ],
  },
  {
    term: "Composite-Schäfte",
    text: [
      "Schäfte, bei denen unterschiedliche Materialien verbunden werden, zum Beispiel Graphit und Stahl.",
    ],
  },
  {
    term: "Course",
    text: [
      "Der Course ist der Platz, also die Summe der Löcher, die ein Golfspieler zu gehen hat.",
    ],
  },
  {
    term: "Course Handicap",
    text: [
      "Es wird vor einem Turnier errechnet und berücksichtigt im Gegensatz zum Handicap Index auch die Schwierigkeit des Platzes. Bei einem durchschnittlich schweren Platz kann sie dem Handicap Index entsprechen, bei einem schweren Platz ist das Course Handicap höher.",
    ],
  },
  {
    term: "Course Rating",
    text: ["Dient der Bewertung des Schwierigkeitsgrades eines Golfplatzes."],
  },
  {
    term: "Course Rating Wert (CR-Wert)",
    text: [
      "Gibt die Schlagzahl an, die ein Golfer mit ungefähr Handicap 0 durchschnittlich auf dem gesamten bewerteten Platz benötigt (beispielsweise 73,1); muss nicht dem Par entsprechen.",
    ],
  },
  {
    term: "Cup",
    text: ["ist der Locheinsatz oder das Loch selbst."],
  },
  {
    term: "Cut",
    text: [
      "Bei den großen Turnieren werden drei oder vier Runden gespielt. Es wird dabei vorab festgelegt, dass nach zwei Runden nur eine bestimmte Anzahl Spieler weiterspielen darf. Die Anzahl wird üblicherweise auf 40 bis 60 Spieler und alle mit gleichen Ergebnissen begrenzt, so dass am Schlusstag bereits relativ früh eine Siegerehrung erfolgen kann.",
      "Ein Grund für einen Cut kann auch sein, dass am Tag nach dem Cut 36 Löcher gespielt werden sollen, was aus Zeitgründen nur einer geringeren Anzahl Spieler möglich ist.",
    ],
  },
  {
    term: "DGV",
    text: [
      "Abkürzung für Deutscher Golf Verband e.V.: Dachverband des Golfsports in Deutschland, zuständig für die Einhaltung der Regeln, Anwendung der Handicap-Regeln und des Course Ratings. Mitglied im DGV sind nur Golfanlagen, aber keine einzelnen Spieler.",
    ],
  },
  {
    term: "Dimple",
    text: [
      "Bezeichnung für kleine Grübchen, die sich auf der Oberfläche des Balls befinden. Die Anzahl, die Form und die Anordnung der Dimples beeinflussen ganz entscheidend die aerodynamischen Eigenschaften des Balls.",
    ],
  },
  {
    term: "Divot",
    text: [
      "Rasenstücke, die beim Golfschwung aus dem Boden geschlagen werden. Die Verhaltensrichtlinien verlangen, dass man sie sorgsam aufsammelt, wieder einsetzt und festtritt.",
    ],
  },
  {
    term: "Dogleg",
    text: [
      "(deutsch Hundebein) Spielbahnen, die nach links oder rechts abgeknickt sind, werden als 'dogleg' bezeichnet. Meistens ist der Knick und damit auch die Sicht auf das Grün erst nach einem guten Drive erreicht.",
    ],
  },
  {
    term: "Doppelbogey",
    text: ["Ergebnis mit zwei Schlägen über Par an einem Loch."],
  },
  {
    term: "Draw",
    text: [
      "Ein Ball, der gerade startet, aber sich letztlich leicht nach links verzieht. Von geübten Spielern wird absichtlich ein Draw gespielt um Wind auszunutzen oder aber um Bäume herum zu spielen.",
    ],
  },
  {
    term: "Drive",
    text: [
      "Jeder Schlag vom Tee wird als Drive bezeichnet - es muss dabei nicht unbedingt der Driver verwendet werden.",
    ],
  },
  {
    term: "Driver",
    text: [
      "Der Schläger mit dem längsten Schaft ist das Holz 1, auch Driver genannt. Der Driver wird fast ausschließlich beim Abschlag vom Tee verwendet.",
    ],
  },
  {
    term: "Driving Range",
    text: [
      "Übungsgelände zum Erlernen der langen Schläge und zum Üben oder Aufwärmen vor der Runde.",
    ],
  },
  {
    term: "Droppen",
    text: [
      "Ein Fallenlassen des Balles nach den Golfregeln, mit in Kniehöhe gehaltenen Ball.",
    ],
  },
  {
    term: "Durchspielen",
    text: [
      "Durchspielen lassen ist eine Pflicht für langsame Spieler oder Gruppen, die einen Ball suchen. Es ist wichtig, weil sie sich sonst von schnelleren Spielern bedrängt fühlen.",
    ],
  },
  {
    term: "Durchschwung",
    text: ["Der Teil des Schwungs nach dem Treffmoment."],
  },
  {
    term: "Eagle",
    text: [
      "(deutsch Adler) Man spricht von einem Eagle, wenn man ein Loch 'zwei unter Par' gespielt hat - also z.B. ein Par-5-Loch in drei Schlägen. Bei allen Ergebnissen, die unter Par liegen, haben sich Begriffe aus der Vogelwelt eingebürgert.",
    ],
  },
  {
    term: "Ehre",
    text: [
      "heißt, vom nächsten Abschlag als Erster abschlagen zu dürfen; teilweise ist dies eine zweifelhafte Ehre, weil der nachfolgende Spieler mit subtiler Genauigkeit beobachten kann, wie Windrichtung und Flugbahn die Ballgeschwindigkeit verändern. Er kann seinen Schlag dann mit einiger Übung ausrichten.",
    ],
  },
  {
    term: "Einstellig",
    text: ["ist jeder Golfer, der eine Stammvorgabe von 9,9 und besser hat."],
  },
  {
    term: "Eisen",
    text: [
      "Der komplette Schlägersatz der Eisen ist durchnummeriert von 1 bis 9 zzgl. Pitching Wedge und Sandwedge. Die Eisen unterscheiden sich zum einen durch die Länge ihrer Schäfte, zum anderen durch seinen Loft (Neigung der Schlagfläche). Den geringsten Loft haben die langen Eisen - den größten Loft schließlich das Wedge.",
    ],
  },
  {
    term: "Erleichterung",
    text: [
      "Nach bestimmten Regeln darf beim Golfspiel Erleichterung genommen werden, d.h. der Ball kann nach den Regeln je nach Ausgangssituation straflos oder mit einem Strafschlag an einer anderen Stelle fallen gelassen werden.",
    ],
  },
  {
    term: "Explosionsschlag",
    text: [
      "Schlag aus dem Bunker, bei dem der Schläger unter dem Ball durch den Sand gleitet und der aufsteigende Sand so aussieht, als sei er durch eine Explosion in die Höhe geworfen worden.",
    ],
  },
  {
    term: "Extra-Löcher",
    text: [
      "Zusätzliche Löcher für ein Stechen, die nach Beendigung eines Wettspiels gespielt werden, um einen Sieger zu ermitteln, wenn das Ergebnis Gleichstand war.",
    ],
  },
  {
    term: "Fade",
    text: [
      "(engl. sprich: fäid) Schlag, bei dem der Ball gerade startet und dann eine leichte Rechtskurve fliegt.",
    ],
  },
  {
    term: "Fahne bedienen",
    text: [
      "Den Flaggenstock halten und gegebenenfalls aus dem Loch ziehen, während der Mitspieler puttet.",
    ],
  },
  {
    term: "Fahnenposition",
    text: [
      "Stelle auf dem Grün, an der das Loch/die Fahne platziert ist. Das Loch wird zur Schonung des Rasens mehrfach wöchentlich versetzt, wobei je nach Anspruch des Wettspiels, für das eine Fahnenposition ausgewählt wird, schwere oder leichte Positionen in einer fairen Mischung denkbar sind.",
    ],
  },
  {
    term: "Fairway",
    text: [
      "Die Spielbahn zwischen Abschlag und Grün mit kurz geschnittenem Rasen.",
    ],
  },
  {
    term: "Fairwayholz",
    text: ["Jedes Holz, das kein Driver ist."],
  },
  {
    term: "Falscher Ball",
    text: [
      'Jeder Ball außer dem "Ball im Spiel", einem "provisorischen Ball" oder einem im Zählspiel nach Regel 20.1c(3) gespielten Ball. Ball im Spiel ist auch der Ball, der den im Spiel befindlichen Ball ersetzt, gleich, ob der Ersatz erlaubt ist oder nicht.',
    ],
  },
  {
    term: "Falsches Grün",
    text: [
      "Dies ist jedes andere Grün als das des zu spielenden Lochs, eingeschlossen ein Übungs- und Annährungsgrün auf dem Platz.",
    ],
  },
  {
    term: "Flex",
    text: ["Die Biegsamkeit des Schaftes."],
  },
  {
    term: "Feedback",
    text: [
      "Die Rückmeldung, die der Spieler nach dem Treffmoment durch den Schläger erhält.",
    ],
  },
  {
    term: "Fett",
    text: [
      "Bei einem fett' getroffenen Ball hat der Schläger zu viel Boden mitgenommen und hinterlässt ein tiefes Divot. Der Ball erhält nur wenig Spin und erreicht selbstverständlich auch nicht die gewünschte Weite.",
    ],
  },
  {
    term: "Flagge",
    text: [
      "Die Flagge, welche an einem Flaggenstock befestigt ist und auf dem Grün im Loch steckt, ist auf weitere Entfernung für den Spieler erkennbar und zeigt ihm seine Schlagrichtung bei richtiger Einschätzung auch in etwa die Entfernung zum Grün an.",
    ],
  },
  {
    term: "Flight",
    text: [
      "(sprich Fleit) Umgangssprachlich benutzter falscher Ausdruck für eine Spielergruppe. Eine Spielergruppe besteht aus mindestens zwei, aber nie mehr als vier Spielern.",
      "Im englischen Sprachgebrauch ist ein Flight eine Wertungsklasse im Turnier oder die Gruppen von 8 Spielern oder Mannschaften, die im Lochspiel gegeneinander antreten.",
    ],
  },
  {
    term: "Fore",
    text: [
      "International üblicher Warnruf bei Gefahr durch fehlgeschlagene Bälle auf dem Golfplatz.",
    ],
  },
  {
    term: "Foursomes",
    text: [
      "Turnierform, bei der ein Team aus zwei Spielern mit einem Ball spielt. Dabei wechseln sich die Spieler mit dem Schlagen ab.",
    ],
  },
  {
    term: "Gelände",
    text: [
      "alles außer Abschlag, Grün und aller Bunker und Penalty Areas auf dem Platz.",
    ],
  },
  {
    term: "Gelbe Pfosten",
    text: [
      "Sie zeigen an, dass sich hier eine Penalty Area (Meer, See, Teich, Fluß, Graben) befindet. Die Penalty Area befindet sich innerhalb der von den gelben Pfosten gesetzten Linien - das bedeutet, dass beispielsweise auch die Uferböschung dazu gehört. Die Pfähle befinden sich innerhalb der Penalty Area.",
    ],
  },
  {
    term: "Geschlossener Stand",
    text: [
      "Der Spieler spricht den Ball an, wobei der rechte Fuß in Relation zur Ziellinie etwas zurückversetzt ist.",
    ],
  },
  {
    term: "Geschlossenes Blatt",
    text: [
      "Das Schlägerblatt zeigt nach links von Ihrem anvisierten Ziel. Oder: das Schlägerblatt zeigt am Ende des Rückschwungs zum Himmel.",
    ],
  },
  {
    term: "Golf",
    text: [
      "Eine faire Sportart, die zu erlernen größte Schwierigkeiten nach sich zieht. Im Altniederländischen wurde die Sportart 'Kolven' betrieben, so dass der Name Golf daher entstanden sein mag.",
    ],
  },
  {
    term: "Golfball",
    text: [
      "Der Golfball hat einen Durchmesser von mindestens 42.67 Millimeter und wiegt höchstens 45,93 Gramm.",
    ],
  },
  {
    term: "Golftasche",
    text: [
      "Die Tasche, in der Schläger und andere Ausrüstung um den Platz transportiert werden.",
    ],
  },
  {
    term: "Golfwagen",
    text: [
      "Ein Karren, auf dem die Golftasche transportiert wird, auch Trolley genannt.",
    ],
  },
  {
    term: "Grain",
    text: [
      "Richtung der Grashalme auf dem Grün. Wird der Ball mit dem Strich geputtet, läuft er schneller als gegen den Strich. Der Grain wird meist durch den Schnitt verursacht.",
    ],
  },
  {
    term: "Graphit",
    text: [
      "Sehr leichtes Material (Carbonfasern), das zur Herstellung von Schäften und Schlägerköpfen verwendet wird.",
    ],
  },
  {
    term: "Greenfee",
    text: [
      "Die zu entrichtende Gebühr für das Spielen auf einem fremden Platz.",
    ],
  },
  {
    term: "Greenkeeper",
    text: [
      "Der für die Platzpflege verantwortliche Mitarbeiter einer Golfanlage.",
    ],
  },
  {
    term: "Grün",
    text: [
      "Eine für das Putten besonders hergerichtete Fläche, in die an wechselnden Stellen das Loch gesetzt wird.",
    ],
  },
  {
    term: "Grün lesen",
    text: [
      "Das Grün zu lesen heisst, die Bodendellen genau zu erfassen und den Ball durch einen gezielten Schlag auf die Reise zu schicken, damit er möglichst in einer bewusst gespielten Kurve das Loch erreicht.",
    ],
  },
  {
    term: "Grooves",
    text: [
      "Die Rillen auf der Schlägerfläche des Schlägers. Diese Rillen nehmen beim Schlag Gras und Erde auf und ermöglichen deshalb einen direkten Kontakt zur Schlagfläche, die dem Ball den Backspin gibt.",
    ],
  },
  {
    term: "Halber Schlag",
    text: [
      "Schlag, bei dem kein voller Schwung ausgeführt, in der Regel, um mit einem längeren Schläger die notwendige Entfernung mit einer flachen Flugbahn zu schlagen, oder mit dem kleinsten Schläger, weil der volle Schlag zu weit gehen würde.",
    ],
  },
  {
    term: "Handicap-Index",
    text: [
      "Der Handicap-Index dient zur Vergleichbarkeit des Spielpotentials. Vielfach und fälschlich als Statussymbol angesehen, letztlich nur ein persönlicher „Rabatt“ auf das Bruttoergebnis des Spielers um ein Nettoergebnis errechnen zu können. Merksatz: Wer wirklich gut spielt, muss nicht allen Leuten von seinem guten Handicap-Index erzählen.",
    ],
  },
  {
    term: "Handicapschoner",
    text: [
      "Golfer, der seine wahren golferischen Fähigkeiten oder sein richtiges Handicap verschweigt, um sich damit einen Vorteil zu verschaffen. Dies wird als schwerer Verstoß gegen die Handicap-Regeln angesehen und kann zur Sperre und Korrektur des Handicap-Index führen.",
    ],
  },
  {
    term: "Heel",
    text: ["Der Teil des Schlägerkopfes unterhalb des Schaftendes."],
  },
  {
    term: "Hemmnisse",
    text: [
      "Ein Hemmnis ist alles Künstliche, eingeschlossen die künstlich angelegten Oberflächen und Begrenzungen von Straßen und Wegen sowie künstliches Eis, jedoch ausgenommen a) Gegenstände zum Bezeichnen des Aus wie Mauern, Zäune, Pfosten und Geländer; b) jeglicher im Aus befindliche Bestandteil eines unbeweglichen künstlichen Gegenstands; und c) jegliche von der Spielleitung zum Bestandteil des Platzes erklärte Anlage.",
    ],
  },
  {
    term: "Hole-In-One",
    text: [
      "Das Spielen einer Spielbahn mit nur einem Schlag vom Abschlag bis ins Loch (vgl. Ass)",
    ],
  },
  {
    term: "Holz",
    text: [
      "Als Hölzer bezeichnet man die Schläger mit dem größeren Schlägerkopf, die im Allgemeinen für die weiteren Schläge Verwendung finden. Das Holz 1 wird auch als Driver bezeichnet, da man es fast ausschließlich für den Drive beim Abschlag vom Tee benutzt.",
      "Schlägerköpfe von Hölzern werden heute meistens aus Metall oder Carbon-Fasern hergestellt, um eine bessere Gewichtsverteilung zu erreichen. Nur in seltenen Fällen findet man noch Hölzer mit „Holzköpfen“",
    ],
  },
  {
    term: "Hook",
    text: [
      "(sprich huhck; deutsch Haken) Wenn der Ball während des Fluges nach links wegdreht, spricht man von einem 'hook'. Jeder Pro wird seinem Schüler erklären, dass der Hook Talent verrät, was sich von einem Slice (hier dreht der Ball nach rechts ab) nicht sagen lässt.",
    ],
  },
  {
    term: "Hosel",
    text: ["Die Verbindung zwischen dem Schaft und dem Schlägerkopf."],
  },
  {
    term: "Identifizierung",
    text: [
      "Die Identifizierung eines Balles ist nach Regel 7.2 erlaubt. Die Lage des Balls muss dabei markiert werden. Der Ball darf dann aufgehoben werden, jedoch nur im zur Identifizierung notwendigen Ausmaß gereinigt werden.",
    ],
  },
  {
    term: "Interlocking Grip",
    text: [
      "Zwischen Zeige- und Mittelfinger der linken Hand liegt der kleine Finger der rechten Hand, eben in einer Art 'Verschluss'.",
    ],
  },
  {
    term: "Junganpflanzung",
    text: [
      "Auf dem Golfplatz frisch angepflanzte Bäume, die zum Beispiel durch einen aufgehäuften Erdwall oder durch stützende Pflöcke erkennbar sind. Meist sind sie blau markiert und man bekommt bei Behinderung einen Freedrop, um sie nicht zu beschädigen.",
    ],
  },
  {
    term: "Kompression",
    text: [
      "Die Maßzahl für jenen Druck, durch den der Ball im Test mit einem Standardgewicht deformiert wird, bezeichnet die Ballhärte. Ein Ball mit C (=Compression) 100 ist härter als ein solcher mit 80 oder 90.",
    ],
  },
  {
    term: "Kurzes Spiel",
    text: [
      "Das kurze Spiel wird für einen guten Score immer notwendig sein und sollte vom Anfänger besonders intensiv auch mit Golflehrern geübt werden. Meistens wird das kurze Spiel, d.h. kurze Annäherungsschläge gegenüber den Abschlägen, sehr vernachlässigt.",
    ],
  },
  {
    term: "Kürzer greifen",
    text: ["Den Schläger weiter unten am Griff fassen."],
  },
  {
    term: "Ladies Captain",
    text: ["Die Leiterin des Damengolfs in einem Golfclub."],
  },
  {
    term: "Langes Spiel",
    text: ["Alle Schläge, die mit langen Eisen und Hölzern gemacht werden."],
  },
  {
    term: "Leading Edge",
    text: ["ist die vordere untere Kante des Schlägerkopfes."],
  },
  {
    term: "Lesen des Grüns",
    text: ["Den Weg bestimmen, auf dem der Ball zum Loch rollen wird."],
  },
  {
    term: "Lie (deutsch: Lage)",
    text: [
      "Die Lage des Balles, nachdem er zum Stillstand gekommen ist.",
      "Der Winkel zwischen Schaft und Boden, der für den korrekten Schwung sehr wichtig ist.",
    ],
  },
  {
    term: "Links",
    text: [
      "Ein Ausdruck für Golf-Plätze, der von den schottischen Küsten-Kursen mit ihren typischen Dünen stammt. Man spricht von 'Links' oder 'Links-Courses'. Ein Charakteristikum liegt darin, dass das neunte Loch am weitesten vom Clubhaus entfernt liegt - man spielt dort hinaus (out), und dann wieder hinein (in). Mit dem deutschen 'links' oder 'rechts' hat das nichts zu tun, sondern mit der Dünenlandschaft an der Küste, die ein „Link“ (ein Bindeglied) zwischen Land und Meer ist.",
    ],
  },
  {
    term: "Lippe",
    text: ["Bunker- oder Lochkante"],
  },
  {
    term: "Loch",
    text: [
      "Das Loch hat einen Durchmesser von viereinviertel Inches (107,9 Millimeter) und eine Tiefe von mindestens vier Inches (101,6 Millimeter). Als Loch bezeichnet man meistens auch die gesamte Spielbahn vom Tee bis zum Loch. Auf 18 Löcher einigte man sich erst 1764, als man in St. Andrews diese Anzahl festlegte; zuvor hatte man in St. Andrews 22 Löcher.",
    ],
  },
  {
    term: "Lochspiel",
    text: [
      "Diese Turnierart zählt nur die gewonnenen Löcher, nicht aber die einzelnen Schläge. Wenn ein Spieler also die ersten 10 Löcher gewinnt, ist ein Lochspiel schon zu Ende.",
    ],
  },
  {
    term: "Loft",
    text: [
      "Die Schrägstellung der Schlagfläche am Schlägerkopf. Das Holz 1 oder Driver hat das geringste Loft aller Schläger - die Neigung liegt meist zwischen acht und zwölf Grad. Das stärkste Loft hat das Wedge - um die 40 Grad. Sandwedges können einen Loft bis sechzig Grad haben. Die Schrägstellung dient dazu, den Ball anzuheben; dadurch ist es überhaupt erst möglich, den Ball fliegen zu lassen. Ein starkes Loft veranlaßt einen steileren, aber auch kürzeren Flug.",
    ],
  },
  {
    term: "Luftschlag",
    text: [
      "ist ein Schlag, bei dem der Ball nicht getroffen wurde, obwohl dies beabsichtigt war. Er zählt als Schlag.",
    ],
  },
  {
    term: "Markieren",
    text: [
      "Die Position des Balles mit einem kleinen runden Objekt festhalten; meistens auf dem Grün.",
    ],
  },
  {
    term: "Mitspieler",
    text: [
      "Der oder die anderen Spieler in der eigenen Spielergruppe. Sie heißen im Zählspiel „Spieler“ oder im Lochspiel „Gegner“",
    ],
  },
  {
    term: "Naturflächen/Biotope",
    text: [
      "Extensiv gepflegte oder der natürlichen Entwicklung überlassene Flächen, in denen durch behördliche Auflagen (Naturschutz) nicht gespielt werden darf. Dies können Wiesen, Hecken oder Teichgebiete sein.",
    ],
  },
  {
    term: "Nearest to the pin",
    text: [
      "Spezialwertung an einem Par-3-Loch. Gewinner ist der Spieler, dem es gelingt, seinen ersten Schlag am nächsten zur Fahne zu platzieren.",
    ],
  },
  {
    term: "Netto",
    text: [
      "Bruttoschlagzahl abzüglich der Vorgabeschläge ergibt das Nettoergebnis. Dient der besseren Vergleichbarkeit unterschiedlicher Spielstärken für einen fairen Wettbewerb und wird zur Ermittlung des Handicaps genutzt.",
    ],
  },
  {
    term:
      "Neunzehntes LochEine gängige Redensart für das Clubhaus bzw. die Clubhaus-Bar. Ein Ort, an dem überhaupt nur erstklassige Schläge und Runden stattfinden.",
    text: [],
  },
  {
    term: "Offener Stand",
    text: [
      "Der Spieler spricht den Ball an, wobei der linke Fuß gegenüber dem rechten Fuß etwas zurückversetzt ist.",
    ],
  },
  {
    term: "Offenes (Schläger)Blatt",
    text: [
      "Das Schlägerblatt zeigt in der Ansprechposition nach rechts vom Ziel oder im Treffmoment nach rechts in Relation zur Ball- Ziellinie.",
    ],
  },
  {
    term: "Out of Bounds",
    text: [
      "Dieser englische Begriff bedeutet 'außerhalb der Grenzen der spielbaren Geländefläche'; Strafschlag und Distanzverlust sind das Resultat, wenn der Ball dort zur Ruhe kommt.",
    ],
  },
  {
    term: "Overlapping Grip",
    text: [
      "Dabei liegt der kleine Finger der rechten Hand über dem Zeigefinger der linken Hand. Ungefähr neunzig Prozent aller Golfspieler verwenden diesen Griff. Er wurde von dem legendären Briten Harry Vardon entwickelt und wird deshalb auch als 'Vardon-Grip' bezeichnet.",
    ],
  },
  {
    term: "Oversize",
    text: [
      "Hölzer, Eisen und Putter, die einen extra großen Schlägerkopf mit verzeihender Treff-Fläche haben, sind gut geeignet für Einsteiger und Wochenendgolfer.",
    ],
  },
  {
    term: "Overspin",
    text: [
      "Vorwärtsdrall des Balles. Bewirkt beim Auftreffen ein Weiterrollen.",
    ],
  },
  {
    term: "Par",
    text: [
      "Par ist die Schlagzahl, die für ein Loch oder einen Platz festgelegt wurde. Beispielsweise ein Par-5-Loch muss in fünf Schlägen gespielt sein, wenn man ein ‚Par' erzielen will.",
    ],
  },
  {
    term: "Partner",
    text: [
      "Die Person, mit der zusammen der Spieler einen Vierer spielt. Beide dürfen sich beraten.",
    ],
  },
  {
    term: "Penalty Area",
    text: [
      "Geländevertiefung, die regelmäßig oder nur saisonbedingt Wasser enthält und die Spielbahn oder Teile davon begleitet.",
    ],
  },
  {
    term: "Pin",
    text: [
      "Als Pin bezeichnet man den Stock, an dem die im Loch steckende Fahne befestigt ist. Wer den Ball 'an den Pin' schlägt, ist gut dran.",
    ],
  },
  {
    term: "Pin Position",
    text: [
      "Bezeichnet die Position der Pin Flag (Fahne), die im Loch am Green steckt und täglich von den Greenkeepern auf jedem Green der Welt umgesteckt wird.",
    ],
  },
  {
    term: "Pitch",
    text: [
      "Kurzer Schlag, bei dem der Ball möglichst steil herabfällt, damit er nicht lange rollt, sondern sofort liegenbleibt.",
    ],
  },
  {
    term: "Pitching Wedge",
    text: [
      "Ein Schläger (Eisen) mit sehr starkem Loft, das dazu führt, dass der Ball steil steigt und steil fällt und möglichst wenig rollt. Wird besonders bei der Annäherung aus der unmittelbaren Nähe des Grüns benutzt.",
    ],
  },
  {
    term: "Pitchmarke",
    text: [
      "Der auf dem Grün landende Ball hinterlässt vor allem in einem weichen Grün ein kleines Loch, das man als Pitchmarke bezeichnet. Es gehört zu den Verhaltensrichtinien, dieses Loch zu entfernen. Dazu gibt es eine Pitch-Gabel, die jeder Spieler bei sich führen sollte, um den Boden für die anderen Spieler wieder ‚auszubeulen'.",
    ],
  },
  {
    term: "Platz",
    text: [
      "Als Platz wird der gesamte Raum bezeichnet, in dem gespielt werden darf.",
    ],
  },
  {
    term: "Platzregel",
    text: [
      "Sogenannte Platzregeln werden von jedem Club entweder zeitweilig oder dauernd erlassen und sind für Gastspieler von besonderer Bedeutung, weil sie durch Kenntnis dieser Regeln eventuell einige Schläge einsparen oder Strafschläge vermeiden können. Platzregeln müssen sich an den Musterplatzregeln aus dem Offiziellen Handbuch zu den Golfregeln orientieren und dürfen nur in den dort genannten Fällen die Regeln abändern.",
    ],
  },
  {
    term: "Platzreife",
    text: [
      "Es handelt sich dabei um eine Prüfung, mit der ein Anfänger die Erlaubnis erringen kann, tatsächlich auf dem Platz zu spielen.",
    ],
  },
  {
    term: "Platzrichter",
    text: [
      "Platzrichter ist jemand, den die Spielleitung bestimmt hat, Spieler zu begleiten, um Tatfragen zu entscheiden und den Regeln Geltung zu verschaffen. Er muss bei jedem Regelverstoß einschreiten, den er beobachtet oder der ihm gemeldet wird. Ein Platzrichter soll nicht den Flaggenstock bedienen, am Loch stehen oder dessen Lage kennzeichnen, und soll auch nicht den Ball aufnehmen oder dessen Lage kennzeichnen.",
    ],
  },
  {
    term: "Pot bunker / Topfbunker",
    text: [
      "Kleiner, tiefer, runder Bunker, der sehr schwer zu spielen ist. Kommt zumeist auf Dünenplätzen vor. Quelle: Falken Verlag - Golf Wissenswertes von A – Z.",
    ],
  },
  {
    term: "Pro",
    text: [
      "Abkürzung für ‚Professional', also einen Berufsspieler. Man unterscheidet hier zwischen einem Playing Pro und einem Teaching Pro. Weibliche Form: Proette. siehe auch „PGA“",
    ],
  },
  {
    term: "Provisorischer Ball",
    text: [
      "Ein provisorischer Ball ist ein Ball, der für einen Ball gespielt wird, welcher außerhalb einer Penalty Area verloren oder Aus sein kann.",
    ],
  },
  {
    term: "Pull",
    text: [
      "Ein Ball mit gerader Flugbahn geschlagen, der links von der Ziellinie verläuft.",
    ],
  },
  {
    term: "Putt",
    text: [
      "Der Putt ist jener Schlag, der meistens auf dem Grün mit dem Putter durchgeführt wird. Der Ball fliegt nicht, sondern rollt.",
    ],
  },
  {
    term: "Putter",
    text: [
      "Der Putter ist jener Schläger, mit dem der Putt durchgeführt wird. Der Ball fliegt nicht, sondern rollt.",
    ],
  },
  {
    term: "Putting Green",
    text: [
      "Das Übungsgrün mit mehreren Übungslöchern dient zum Üben des Puttens. Achtung: Im Englischen ist das Putting Green das Grün jedes zu spielenden Lochs.",
    ],
  },
  {
    term: "Push",
    text: [
      "Das Gegenteil von Pull. Ball mit gerader Flugbahn, die rechts von der Ziellinie verläuft.",
    ],
  },
  {
    term: "Range",
    text: ["siehe Driving Range"],
  },
  {
    term: "Rangefee",
    text: [
      "Gebühr, die man als Gast in einem Golfclub für die Benutzung der Übungsanlagen entrichten muss. Die Driving-Range-Bälle müssen meist zusätzlich bezahlt werden.",
    ],
  },
  {
    term: "Recovery",
    text: ["Schlag aus einer schlechten Lage heraus"],
  },
  {
    term: "Regeln",
    text: [
      "Die ersten Regeln wurden 1744 bei der Gründung der 'Honourable Company of Edinburgh Golfers' formuliert. Es handelte sich damals lediglich um 13 Gebote (heute 24).",
    ],
  },
  {
    term: "Rote Pfosten",
    text: ["zeigen eine Penalty Area an"],
  },
  {
    term: "Rough",
    text: [
      "Das Rough wird in den Regeln nicht besonders definiert. Praktisch bezeichnet man alles, was außerhalb der Fairways oder Grüns liegt, als Rough (alle jene Flächen mit höherer Schnitthöhe als die Fairways).",
    ],
  },
  {
    term: "Rückschwung",
    text: [
      "Die Phase des Schwungs, in der sich der Schlägerkopf vom Ball wegbewegt bis zu dem Moment, in dem sich der Schlägerkopf nach unten bewegt. Hoffentlich ist Ihr Rückschwung ruhig.",
    ],
  },
  {
    term: "Runde",
    text: [
      "Unter einer Runde Golf versteht man normalerweise das Spielen von achtzehn oder neun Löchern. Weitere Runden sind vom Neunzehnten Loch bekannt - sie haben aber kaum etwas mit der praktischen Ausübung des Spiels zu tun.",
    ],
  },
  {
    term: "Sandbunker",
    text: [
      "Besonders zahlreich um die Greens gelegen, verscherzen manchem Golfer einen anständigen Score, aber auch ein Sandbunker als Fairwaybunker auf halber Strecke bedarf eines besonderen Könnens, um von dort die Reststrecke eventuell mit einem Schlag zu überwinden.",
    ],
  },
  {
    term: "Sandwedge",
    text: [
      "Ein erst in den dreißiger Jahren von Gene Sarazen erfundener Schläger mit starkem Loft und einer besonders geformten Sohle, der sich vor allem für die Schläge aus dem Sand eines Bunkers eignet. Der Schlägerkopf wird dabei unter dem Ball durch den Sand geführt, so dass der Ball steil herausgehoben wird und, nach entsprechend kurzen Flug, landet - möglichst auf dem Grün.",
    ],
  },
  {
    term: "Schaft",
    text: [
      "Die Schäfte von Schlägern wurden bis in die zwanziger Jahre ausschließlich aus Hickory-Holz hergestellt, das durch seine Langfaserigkeit über eine besondere Zähigkeit verfügte. Danach setzte sich mehr und mehr der Stahlschaft durch. In den achtziger Jahren begann der Erfolg der Kunststoff-Schäfte. Entscheidend ist bei einem Schaft nicht nur die gesamte Flexibilität. Je nach Bedarf oder persönlicher Vorliebe verschiebt sich der besonders flexible Teil des Schaftes nach oben oder nach unten. Anfänger sollten sich da besonders sorgfältig beraten lassen.",
    ],
  },
  {
    term: "Schlag",
    text: ["Bewegung des Schlägers mit der Absicht, den Ball zu treffen."],
  },
  {
    term: "Schlägerblatt",
    text: ["ist die Schlagfläche des Schlägerkopfes."],
  },
  {
    term: "Schläger ausrichten",
    text: [
      "Das Platzieren des Schlägers hinter dem Ball in der Ansprechposition.",
    ],
  },
  {
    term: "Schnupperkurs",
    text: [
      "Ein Unterricht, bei dem Interessenten zunächst einmal die Gelegenheit gegeben wird, das Golfspiel vorgestellt zu bekommen, ohne einem Club beitreten zu müssen.",
    ],
  },
  {
    term: "Schwung",
    text: [
      "(englisch swing) Damit ist der gesamte Bewegungsablauf beim Schlag eines Balles gemeint. Entscheidend bleibt, dass die Schlagfläche des Schlägerkopfes 'square' an den Ball gebracht wird und im Moment des Ballkontaktes ihre größte Geschwindigkeit erreicht; man kann davon ausgehen, dass es wahrscheinlich keine zwei Menschen gibt, die über genau den gleichen Schwung verfügen.",
    ],
  },
  {
    term: "Scorekarte",
    text: [
      "Der Score wird nach dem Spielen von jedem Loch in die entsprechende Spalte der Scorekarte eingetragen, so dass sich nach 18 Löchern leicht der Gesamt-Score addieren lässt.",
    ],
  },
  {
    term: "Scratch",
    text: ["Ein 'Scratch-Spieler' hat den Handicap-Index Null."],
  },
  {
    term: "Semirough",
    text: [
      "Roughstreifen zwischen Fairway und Rough, dessen Schnitthöhe zwischen der des Fairways und der des Roughs liegt.",
    ],
  },
  {
    term: "Senior",
    text: [
      "Ein Senior ist nicht etwa ein Spieler, der durch verminderte physische Kräfte oder durch ein schlechteres psychologisches Nervenkostüm als Senior, bezeichnet werden müsste, sondern man wird im Golfsport in dem Moment Senior, in weichem das 50. Lebensjahr erreicht ist.",
    ],
  },
  {
    term: "Slice",
    text: [
      "Bei einem Slice beschreibt der Ball einen Bogen nach rechts und verschwindet meisten spurlos im tiefsten Rough oder einem Gewässer. Es soll Spieler geben, die in vielen Jahren noch nie die linke Seite eines Fairways aus der Nähe gesehen haben. Wenn der Ball den gleichen schönen Bogen nach links beschreibt, handelt es sich um einen Hook.",
    ],
  },
  {
    term: "Slope-Wert",
    text: [
      "Setzt die Schwierigkeitswerte eines Golfplatzes für Scratch-(Hcp. circa 0-5) und Bogey- (Hcp. circa 18-22) Golfer ins Verhältnis. Er kann zwischen 55 und 155 liegen. (Dieser Wert sorgt im Wesentlichen dafür, dass sich die Vorgabe jedes Spielers je nach Spielstärke an die Schwierigkeit des zum Spiel ausgewählten Golfplatzes anpasst).",
    ],
  },
  {
    term: "Sohle",
    text: ["Die Fläche, mit der das Eisen auf dem Boden aufliegt."],
  },
  {
    term: "Spielbahn/Golfbahn",
    text: [
      "Der Bereich innerhalb der Platzgrenzen (Ausgrenze), den der Spieler auf dem Weg vom Abschlag zum Grün üblicherweise zu überwinden hat.",
    ],
  },
  {
    term: "Spiellinie",
    text: [
      "Die unsichtbare Linie auf dem Grün zwischen Ball und Loch, die so schwierig zu finden und auch noch zu treffen ist. Jeder Spieler vermeidet es, seine eigene Linie oder die eines Mitspielers zu betreten. Die Spikes der Schuhe können da in der Tat Spuren hinterlassen, die den Lauf des Balles nicht unwesentlich beeinflussen.",
    ],
  },
  {
    term: "Square",
    text: [
      "Wenn die Schlägerfläche eines Schlägers in einem Winkel von neunzig Grad zur angenommenen Ziellinie steht, spricht man davon, dass sie 'square' ist. Es ist die Voraussetzung für einen geraden Schlag.",
      "Der Körper, Fußspitzen, Schultern sollten parallel zur Ziellinie ausgerichtet sein.",
      "Wenn zwei oder mehr Spieler gleichauf liegen, liegen sie 'square' oder 'even'.",
    ],
  },
  {
    term: "Stableford",
    text: [
      "Diese von einem britischen Arzt erfundene Spielart ist für den Anfänger deswegen geeignet, weil er ein Loch, welches zweistellig gespielt wird, sofort vergessen und durch eine bessere Spielweise auf anderen Löchern den Gesamtscore retten kann.",
    ],
  },
  {
    term: "Stammvorgabe",
    text: ['siehe "Handicap Index".'],
  },
  {
    term: "Stand",
    text: [
      "Zur Durchführung eines Golfschlages bedarf es eines gewissen Standes der Füße. Er wird von Golflehrer zu Golflehrer natürlich unterschiedlich unterrichtet.",
    ],
  },
  {
    term: "Startzeit",
    text: ["Festgesetzter Zeitpunkt, zu dem abgeschlagen wird."],
  },
  {
    term: "Sweet spot",
    text: [
      "Der ideale Auftreffpunkt auf dem Schlägerblatt, an welchem die größte Schlagkraft übertragen wird.",
    ],
  },
  {
    term: "Tee",
    text: [
      "Das Wort hat zwei Bedeutungen im Golf. Zunächst ist es der Abschlag, von der zu Beginn einer Spielbahn der erste Schlag vorgenommen wird. Es ist auch jener kleine Stift aus Holz oder Plastik, auf den man den Ball für den Abschlag legt.",
    ],
  },
  {
    term: "Tigerline",
    text: [
      "Extrem weiter und riskanter Schlag in direkter Linie - meist bei einem Dogleg - wo andere Spieler den sicheren, aber längeren Weg am Fairway vorziehen. Der Begriff hat nichts mit Tiger Woods zu tun, sondern ist älteren Ursprungs.",
    ],
  },
  {
    term: "Toe",
    text: ["Der am weitesten vom Schaft entfernte Teil des Schlägerkopfes."],
  },
  {
    term: "Token",
    text: [
      "Bedeutet im englischen tokenmoney = Ersatzgeld oder Notgeld. Token erhält man gegen Bargeld an der Rezeption eines Golfclubs und man verwendet sie am Golfballautomaten an der Drivingrange. Die meisten Golfballautomaten nehmen mittlerweile 1-Euro- oder 2-Euro-Münzen anstatt des Tokens.",
    ],
  },
  {
    term: "Toppen",
    text: [
      "Wenn der Ball im Treffmoment nicht genau, sondern ab der Mitte oder oberhalb getroffen wird, so entsteht daraus ein kurzer holpriger Schlag, der Ball ist 'getoppt'. Der persönliche Ärger oder das Mitleid der Mitspieler ist dann meist sehr ergreifend.",
    ],
  },
  {
    term: "Trailing Edge",
    text: [
      "Hintere Kante der Sohle im Schlägerkopf (vorwiegend bei Sand Wedges).",
    ],
  },
  {
    term: "Treffmoment",
    text: ["Der Moment, in dem der Schlägerkopf den Ball trifft."],
  },
  {
    term: "Triple Bogey",
    text: [
      "Der Tripie Bogey ist nichts weiter als drei Schläge über Par gespielt. Dieser nicht oft benutzte Ausdruck klingt aber fachmännischer, als wenn man schlechthin 'Drei über Par' sagt.",
    ],
  },
  {
    term: "Trolley",
    text: ["Das Wägelchen, mit dem man seine Golftasche transportiert."],
  },
  {
    term: "Troubleshot",
    text: ["ist ein Schlag aus einer schwierigen Lage."],
  },
  {
    term: "Unspielbarer Ball",
    text: [
      "Jeder Ball kann nach den Golfregeln, außer bei Penalty Areas, vom Spieler für unspielbar erklärt werden und unter Hinzurechnung eines Strafschlages nach den Regeln neu fallen gelassen werden. Diese taktische Maßnahme erspart in vielen Fällen zusätzliche Schläge.",
    ],
  },
  {
    term: "Unter",
    text: [
      "(engl. under) Bei den großen Turnieren spricht man kaum einmal davon, wie viel Schläge ein Spieler bisher benötigte - man sagt vielmehr, wieviel er 'unter' liegt. Gemeint ist unter Par. Wenn der Spieler auf dem Platz mit Einheit 72 nur siebzig Schläge benötigte, liegt er 'zwei unter' oder 'minus zwei'. Weniger gut ist 'über' oder 'plus'.",
    ],
  },
  {
    term: "Up and down",
    text: [
      "Den Ball aus einer beliebigen Lage rund ums Grün mit zwei Schlägen ins Loch zu bekommen.",
    ],
  },
  {
    term: "Verhaltensrichtlinien",
    text: [
      "Dazu gehören Richtlinien zur Sicherheit und Rücksichtnahme auf dem Platz, zum Vorrecht auf dem Platz und zur Schonung des Platzes. Schwerwiegende Verstöße dagegen können mit Disqualifikation bestraft werden",
    ],
  },
  {
    term: "Verlorener Ball",
    text: [
      "Ein Ball ist dann verloren, wenn er nach den Regeln nicht innerhalb von fünf Minuten wiedergefunden ist. In der Logik der Golfer gibt es Situationen, wo es manchmal wirklich besser ist, dass ein Ball trotz intensiven Suchens nicht wieder gefunden wird, aber meistens hat man ja das Glück, zahlreiche andere Bälle zu finden, nur nicht seinen eigenen.",
    ],
  },
  {
    term: "Vorgrün",
    text: [
      "Direkte Umgebung des Grüns, zumeist kürzer als das Fairway gemäht (ca. 6 bis 12 mm).",
    ],
  },
  {
    term: "Waggling",
    text: [
      "bedeutet nichts weiter als ein Wackeln, entweder mit dem Schlägerkopf, mit den Handgelenken oder sogar, wie man es beobachten kann, mit dem gesamten Körper. Das führt eine Lockerung der Muskulatur herbei und ermöglicht dadurch einen leichteren und besseren Durchschwung.",
    ],
  },
  {
    term: "Wedge",
    text: [
      "Ein Schläger für Annäherungsschläge mit einem starken Loft, welcher hohe kurze Schläge ermöglicht.",
    ],
  },
  {
    term: "Wind",
    text: [
      "Die Berücksichtigung des Windes in seiner Richtung und Stärke ist erst möglich für routinierte Spieler. Aber wer einmal auf Links gespielt hat, weiß, um wie viele Meter ein Ball am Green vorbeifliegen kann - nur durch plötzlich auftretende Windböen.",
    ],
  },
  {
    term: "Wintergrün",
    text: [
      "Grün, das vor allem im Winter angespielt wird, um das normale Grün zu schonen.",
    ],
  },
  {
    term: "Yips",
    text: [
      "Eine mental bedingte innere Sperre, die vor allem beim Putt auftreten kann - auch Pianisten oder Stenografen können darunter leiden. Es hat erstklassige Golf-Profis gegeben, die das erst nach langen Mühen (manchmal auch psychologischer Behandlung) zu überwinden vermochten, z. B. Bernhard Langer - andere gaben das Spiel sogar auf.",
    ],
  },
  {
    term: "Zähler",
    text: [
      "Zähler ist jemand, den die Spielleitung zum Aufschreiben der Schlagzahl eines Spielers im Zählspiel bestimmt hat. Er kann auch mitspielen. Er ist nicht Platzrichter.",
    ],
  },
  {
    term: "Zählspiel",
    text: [
      "Das heute überall geläufige Spiel, bei dem der Spieler mit der geringsten Schlagzahl gewonnen hat. Das Zählspiel wurde erst 1759 begonnen, natürlich in Schottland. Vorher trug man fast ausschließlich Lochspiele aus, bei denen man nachher die Zahl der gewonnen Löcher zählt.",
    ],
  },
  {
    term: "Zeitweiliges Wasser",
    text: [
      "kann oftmals durch Regen oder kurze Schauer auftreten. Selbst Schnee zählt zu zeitweiligem Wasser, eine Matschfläche aber nicht. Bei zeitweiligem Wasser kann der Ball entsprechend den Regeln straflos neu gedroppt werden.",
    ],
  },
];

const glossar = elems;
/*
const glossar = elems.map((e) => {
  const strings = e.split("\n").filter((s) => !!s);
  return {
    term: strings[0],
    text: strings.slice(1),
  };
});
console.log(JSON.stringify(glossar, null, 2))
*/

let filterValue, filteredGlossar;
const filter = () => {
  const fv = filterValue.toLowerCase();
  filteredGlossar = glossar.filter((g) => {
    if (g.term.toLowerCase().indexOf(fv) !== -1) {
      return true;
    }
    for (let i = 0; i < g.text.length; i++) {
      if (g.text[i].toLowerCase().indexOf(fv) !== -1) {
        return true;
      }
    }
    return false;
  });
};

let glossarShown = false;
let fadeGlossar = false;

const toggleGlossar = () => {
  glossarShown ? hideGlossar() : showGlossar();
};

const showGlossar = () => {
  glossarShown = true;
  setTimeout(() => (fadeGlossar = true), 0);
};
const hideGlossar = () => {
  fadeGlossar = false;
  setTimeout(() => (glossarShown = false), 500);
};

onMount(() => {
  filteredGlossar = glossar;
});
</script>

<style lang="scss">
.glossar {
  opacity: 0;
  z-index: 50;
  position: fixed;
  right: 0;
  top: 65px;
  bottom: 5px;
  width: 25vw;
  padding: 10px;
  background: #fff;
  border: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-right: none;
  transition: all 0.3s ease;
}
.glossar-visible {
  opacity: 1;
}
.glossar-count {
  margin: 5px 0;
}
.glossar-content {
  overflow-y: scroll;
  max-height: 85%;
}
.glossar-item {
  padding: 10px 0;
}
.glossar-term {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
